function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.1875 9.6h2.625c0 .7732-.5876 1.4-1.3125 1.4s-1.3125-.6268-1.3125-1.4zm.4688-8.2866C2.2005 1.7128 1.125 3.1218 1.125 4.7998v2.3998c0 .2212-.1684.4004-.3746.4004C.336 7.6 0 7.959 0 8.4v.6006C0 9.1108.0834 9.2.188 9.2h8.624c.1038 0 .188-.0906.188-.1994V8.4c0-.4418-.3375-.8-.7504-.8-.2068 0-.3746-.1778-.3746-.4004V4.7998c0-1.6774-1.0753-3.0868-2.5313-3.4864V.9002C5.3438.4018 4.966 0 4.5 0c-.465 0-.8438.403-.8438.9002v.4132z",
  fill: "#5284FF",
  fillRule: "evenodd"
});

const SvgBell = (_ref) => {
  let {
    svgRef
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 9,
    height: 11,
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bell.3b63b1ce.svg";
export { ForwardRef as ReactComponent };